export interface TrainType {
  id: number;
  description: string;
}

export enum TrainTypeId {
  Cargo = 1001,
  Passenger = 1000,
  Locomotive = 1002,
  Maintenance = 1003,
  Emergency = 1004,
  Mixed = 1005,
  Other = 1006
}
